import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const DashboardSkeleton = () => {
    const [progress, setProgress] = useState(0);
    const [loadingTextIndex, setLoadingTextIndex] = useState(0);
    const { t } = useTranslation();

    const loadingTexts = [t("loading.data.message"), t("loading.done.message")];

    useEffect(() => {
        const progressInterval = setInterval(() => {
            setProgress((prevProgress) =>
                prevProgress >= 100 ? 0 : prevProgress + 2
            );
        }, 100);

        const textInterval = setInterval(() => {
            setLoadingTextIndex(
                (prevIndex) => (prevIndex + 1) % loadingTexts.length
            );
        }, 1000);

        return () => {
            clearInterval(progressInterval);
            clearInterval(textInterval);
        };
    }, [loadingTexts.length]);

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            height="100vh"
            gap="40px"
            sx={{ backgroundColor: "#fffff" }}
        >
            <img
                src="/assets/Logo-SSC.png"
                width={240}
                height={240}
                alt="Smart Santé Conseil"
            />

            <Typography variant="h6" sx={{ color: "#3d3d3d", fontWeight: 500 }}>
                {loadingTexts[loadingTextIndex]}
            </Typography>

            <Box sx={{ width: "80%", maxWidth: 600 }}>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        height: 10,
                        borderRadius: 5,
                        "& .MuiLinearProgress-bar": {
                            borderRadius: 5,
                            backgroundColor: "#E53935",
                        },
                    }}
                />
                <Typography
                    variant="body2"
                    align="center"
                    mt={1}
                    sx={{ color: "#E53935", fontWeight: 600 }}
                >
                    {progress}%
                </Typography>
            </Box>
        </Stack>
    );
};
